import React, { useState, useContext } from "react";
import { AdminStateContext } from "../../../../providers/AdminStateProvider.jsx";
import { getERPSyncOverview, getERPSyncStrategies } from "../../../../api/index.js";
import useApi from "../../../../hooks/useApi.js";
import { useAuthToken } from "../../../../hooks/AuthHook.jsx";
import StrategyTable from "../components/StrategyTable/StrategyTable.jsx";
import SyncStatsOverview from "../components/SyncStatsOverview/SyncStatsOverview.jsx";
import SyncProgressCard from "../components/SyncProgressCard/SyncProgressCard.jsx";
import SyncHeader from "../components/SyncHeader/SyncHeader.jsx";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage.jsx";


const SyncOverview = () => {
    const [adminState] = useContext(AdminStateContext);
    const { country } = adminState;
    const authToken = useAuthToken();
    const [period, setPeriod] = useState(new Date().toISOString().slice(0, 7));

    const {
        data: overview,
        loading: overviewLoading,
        error: overviewError,
        refetch: refetchOverview
    } = useApi(
        () => {
            if (!authToken) return null;
            return getERPSyncOverview(country, period, authToken);
        },
        [country, period, authToken]
    );

    const {
        data: strategies,
        loading: strategiesLoading,
        error: strategiesError,
        refetch: refetchStrategies
    } = useApi(
        () => {
            if (!authToken) return null;
            return getERPSyncStrategies(country, period, authToken);
        },
        [country, period, authToken]
    );

    // Combine loading and error states
    // If we don't have a token yet, we are effectively "loading" the auth state
    const loading = !authToken || overviewLoading || strategiesLoading;
    const error = overviewError || strategiesError;

    const handlePeriodChange = (value) => {
        setPeriod(value);
    };

    const handleRetry = () => {
        refetchOverview();
        refetchStrategies();
    };

    if (loading && !overview) {
        return <div style={{ padding: "20px", fontFamily: "sans-serif" }}>Cargando...</div>;
    }

    if (error && !overview) {
        return (
            <ErrorMessage>
                <ErrorMessage.Icon error={error} />
                <ErrorMessage.Title error={error} />
                <ErrorMessage.Message error={error} />
                <ErrorMessage.Actions>
                    <ErrorMessage.RetryButton onClick={handleRetry} />
                    <p style={{ marginTop: "30px", marginBottom: "0px", fontSize: "12px", color: "#666", textAlign: "center" }}>
                        Puede que el periodo seleccionado no tenga datos.
                        Prueba con otro periodo.
                    </p>
                    <SyncHeader.PeriodSelector
                        value={period}
                        onPeriodChanged={handlePeriodChange}
                    />
                </ErrorMessage.Actions>
            </ErrorMessage>
        );
    }

    return (
        <>
            <SyncHeader>
                <SyncHeader.TitleSection>
                    <SyncHeader.Title>ERP Asientos</SyncHeader.Title>
                    <SyncHeader.Subtitle>
                        País: {country} · Período: {period}
                    </SyncHeader.Subtitle>
                </SyncHeader.TitleSection>
                <SyncHeader.Actions>
                    <SyncHeader.PeriodSelector
                        value={period}
                        onPeriodChanged={handlePeriodChange}
                    />
                </SyncHeader.Actions>
            </SyncHeader>

            {overview && (
                <>
                    <SyncProgressCard overview={overview} />
                    <SyncStatsOverview overview={overview} />
                </>
            )}

            <StrategyTable
                strategies={strategies?.strategies}
                loading={loading}
            />
        </>
    );
};

export default SyncOverview;
